import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { CTA } from "../components/site/CTA";
import { SERVICES } from "../data/services";

export default function Services() {
  return (
    <>
      <PageHero
        testid="services-hero"
        eyebrow="Services"
        lines={["Every registration,", <span className="font-serif-i text-[var(--brass-deep)]">its own rulebook.</span>]}
        intro="Choose your vertical to see how we support registration, ongoing compliance, audits and inspections."
      />
      <section className="bg-paper py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-row-${s.slug}`}
                className="group relative grid grid-cols-[auto_1fr_auto] items-center gap-5 sm:gap-10 py-8 sm:py-12 border-b border-ink/15 overflow-hidden"
              >
                <span className="absolute inset-0 bg-ink origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-500 ease-out" />
                <span className="relative font-mono-x text-sm text-[var(--brass-deep)] group-hover:text-brass transition-colors pl-2">0{i + 1}</span>
                <span className="relative">
                  <span className="block font-display font-extrabold tracking-[-0.03em] text-3xl sm:text-5xl lg:text-6xl group-hover:text-paper transition-colors duration-500">
                    {s.title} <span className="font-serif-i font-normal text-[var(--brass-deep)] group-hover:text-brass">({s.code})</span>
                  </span>
                  <span className="block mt-3 max-w-2xl text-sm sm:text-base text-ink/70 group-hover:text-paper/75 transition-colors duration-500">{s.short}</span>
                </span>
                <span className="relative grid place-items-center w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-ink/25 group-hover:border-brass group-hover:text-brass group-hover:rotate-45 transition-[transform,color,border-color] duration-500 mr-2">
                  <ArrowUpRight className="w-5 h-5 sm:w-6 sm:h-6" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTA />
    </>
  );
}
